require './account'

App.StaffMember = StaffMember = App.Account.extend
  role:          DS.attr 'string', defaultValue: 'admin'
  notifications: DS.attr 'mixed',  defaultValue: App.Account.DEFAULT_NOTIFICATIONS

  disabled:     DS.attr 'boolean'

  sip_enabled:  DS.attr 'boolean'
  sip_login:    DS.attr 'string'
  sip_password: DS.attr 'string'

  organization: DS.belongsTo 'organization', async: true
  restaurants:  DS.hasMany   'restaurant',   async: true
  cooking_lines:  DS.hasMany 'cooking_line',   async: true

  notification_url: DS.attr 'string'

  email_disabled: DS.attr 'boolean'
  email_confirmed: DS.attr 'boolean'

  business_role:  DS.belongsTo 'business_role', async: true

  isAdmin:          Em.computed.equal 'role', 'admin'
  isRegionalAdmin:  Em.computed.equal 'role', 'regional_admin'
  isManager:        Em.computed.equal 'role', 'manager'
  isManagerLogist:  Em.computed.equal 'role', 'manager_logist'
  isLogist:         Em.computed.equal 'role', 'logist'

StaffMember.DEFAULT_NOTIFICATIONS  = App.Account.DEFAULT_NOTIFICATIONS
StaffMember.DISABLED_NOTIFICATIONS = App.Account.DISABLED_NOTIFICATIONS

module.exports = StaffMember
